"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heading = void 0;
var _react = _interopRequireDefault(require("react"));
var _ButtonIcon = require("b2b-components/core/components/ButtonIcon");
var _ModalButtons = require("b2b-components/core/components/Modal/ModalButtons");
require("./Heading.scss");
const Heading = _ref => {
  let {
    title,
    onClose,
    hideCloseButton
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Modal-Heading"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "cds-Modal-Title"
  }, title), /*#__PURE__*/_react.default.createElement("h4", {
    className: "cds-Modal-Title"
  }, title), !hideCloseButton && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Modal-CloseButtonWrapper"
  }, /*#__PURE__*/_react.default.createElement(_ButtonIcon.ButtonIcon, {
    tabIndex: _ModalButtons.MODAL_BUTTON_SELECT_PRIORITIES.x,
    "aria-label": "close-modal",
    className: "cds-Modal-CloseButton",
    icon: _ButtonIcon.BUTTON_ICON_ICON_NAME.close,
    onClick: onClose,
    size: _ButtonIcon.BUTTON_ICON_SIZE.medium,
    styleType: _ButtonIcon.BUTTON_ICON_STYLE_TYPE.ghost
  })));
};
exports.Heading = Heading;
//# sourceMappingURL=Heading.js.map